// extracted by mini-css-extract-plugin
export var planCard = "_s9-0";
export var planList = "_s9-1";